import React, {useEffect, useState} from "react";
import localization from "assets/localization/localization";
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import '../../main.css'
import Layout from 'components/sales/layout/layout';
import SiteInformationForm from 'components/fileComplain/formSection/siteInformationForm/valetFilter';
const ListTag = ({
                     tagList,
                     tagListing = []
                 }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [listData, setListData] = useState([]);

    // useEffect(() => {
    //     const tableData = ['id', 'tag_sequence', 'url'];
    //     if (tagListing && tagListing.length > 0) {
    //         const data = tagList.map((element) => {
    //             Object.assign(
    //                 {},
    //                 ...tableData.map((key) => ({[key]: element[key]})),
    //             )
    //         });
    //         if (data) {
    //             setListData(data);
    //         }
    //     }
    // }, [tagListing]);

    return (
        <>
            <Layout title={localization.tagList}
                    isLoading={isLoading}>
                <div className="row">
                    <div className="col-md-12">
                        <PanelCardWithHeading
                            title={localization.Filter}
                            isLoading={isLoading}
                        >
                            <SiteInformationForm
                                isLoading={isLoading}
                                setIsLoading={setIsLoading}
                                siteInformationData={async (val) => {
                                    setIsLoading(true);
                                    await tagList(val?.projectId);
                                    setIsLoading(false);
                                }}
                            />
                        </PanelCardWithHeading>
                    </div>
                    <div className="col-md-12">
                        {listData && tagListing.length > 0 && (
                            <PanelCardWithHeading title={localization.tagList}>
                                <table className="panel-table table table-bordered">
                                    <thead>
                                    <tr>
                                        <th>S No</th>
                                        <th>Id</th>
                                        <th>Tag Sequence</th>
                                        <th>url</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {tagListing.length > 0 ?
                                        <>
                                            {tagListing.map((val, key) => {

                                                return (<tr key={{key}}>
                                                    <td>{key + 1}</td>
                                                    <td>{val.id}</td>
                                                    <td>{val.tag_sequence}</td>
                                                    <td><a href={val.url} alt={""} target="_blank">Url</a></td>
                                                </tr>);
                                            })}
                                        </>
                                        : null}
                                    </tbody>
                                </table>
                            </PanelCardWithHeading>
                        )}
                    </div>
                </div>


            </Layout>
        </>
    )
}

export default ListTag